// kontroll-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'ktr.title': 'Review',
  'ktr.subtitle': 'Work waiting for someone other than the person who did it to vouch for it.',
  'ktr.view.matrix': 'Matrix',
  'ktr.view.list': 'Review list',
  'ktr.refresh': 'Refresh',
  'ktr.notController': 'The firm has not declared you a reviewer. You can see the reviews but not approve them.',
  'ktr.empty.title': 'Nothing to review',
  'ktr.empty.text': 'A review is created when someone sends a reconciled period for review from the reconciliation folder.',
  'ktr.controlNotFound': 'Could not find the review. Do you have access to this account book?',
  'ktr.kpi.new': 'New for review',
  'ktr.kpi.active': 'In progress',
  'ktr.kpi.awaitingPerformer': 'Waiting for performer',
  'ktr.kpi.due7': 'Due in the next 7 days',
  'ktr.kpi.overdue': 'Deadline passed',
  'ktr.kpi.approved': 'Approved',
  'ktr.search.placeholder': 'Search by client or org. no.',
  'ktr.search.label': 'Search for client',
  'ktr.filter.allScopes': 'All scopes',
  'ktr.filter.allPerformers': 'All performed by',
  'ktr.filter.allStatuses': 'All statuses',
  'ktr.filter.clientGroup': 'Client group',
  'ktr.filter.allClientGroups': 'All client groups',
  'ktr.filter.allDeadlines': 'All deadlines',
  'ktr.filter.next7Days': 'Next 7 days',
  'ktr.filter.onlyMine': 'Only my reviews',
  'ktr.filter.onlyDeviations': 'Only with deviations',
  'ktr.filter.reset': 'Reset',
  'ktr.filter.showing': 'Showing:',
  'ktr.filter.remove': 'Remove filter',
  'ktr.history.empty': 'No history yet.',
  'ktr.history.system': 'The system',
  'ktr.history.submitted': 'sent the period for review',
  'ktr.history.resubmitted': 'resubmitted (version {version})',
  'ktr.history.pointUpdated': 'assessed a review point',
  'ktr.history.approved': 'approved the review (version {version})',
  'ktr.history.returned': 'returned to the performer – {note}',
  'ktr.history.reopened': 'reopened the review – {reason}',
  'ktr.history.assigned': 'assigned the review to a reviewer',
  'ktr.history.unassigned': 'put the review back in the queue',
  'ktr.history.documentationRequested': 'requested documentation – {note}',
  'ktr.history.documentationResolved': 'marked the documentation as received',
  'ktr.history.basisChanged': 'the books changed after approval',
  'ktr.status.new': 'New',
  'ktr.status.underControl': 'Under review',
  'ktr.status.awaitingDocs': 'Waiting for documentation',
  'ktr.status.returned': 'Returned to performer',
  'ktr.status.resubmitted': 'Resubmitted',
  'ktr.status.approved': 'Reviewed and approved',
  'ktr.status.changedAfter': 'Changed after approval',
  'ktr.action.start': 'Start review',
  'ktr.action.continue': 'Continue review',
  'ktr.action.seeStatus': 'See status',
  'ktr.action.reviewChanges': 'Review changes',
  'ktr.action.seeApproved': 'See approved review',
  'ktr.wholePeriod': 'Whole period',
  'ktr.point.notAssessed': 'Not assessed',
  'ktr.point.ok': 'OK',
  'ktr.point.remark': 'Remark',
  'ktr.point.mustFix': 'Must be corrected',
  'ktr.point.fromReconciliation': 'From the reconciliation',
  'ktr.point.sourceLine': 'Account {account} · unexplained {amount} kr',
  'ktr.point.openSource': 'Open in the basis',
  'ktr.point.observedPlaceholder': 'What was observed?',
  'ktr.fix.responsibleLabel': 'Person responsible for the correction',
  'ktr.fix.responsiblePlaceholder': 'Responsible …',
  'ktr.fix.deadlineLabel': 'Deadline for the correction',
  'ktr.fix.linkedPlaceholder': 'Linked to (account, voucher or section)',
  'ktr.fix.linkedLabel': 'Linked to',
  'ktr.deadline.none': 'No deadline',
  'ktr.deadline.overdueOne': '{date} · overdue by {days} day',
  'ktr.deadline.overdueMany': '{date} · overdue by {days} days',
  'ktr.deadline.today': '{date} · today',
  'ktr.deadline.inOne': '{date} · in {days} day',
  'ktr.deadline.inMany': '{date} · in {days} days',
  'ktr.priority.high': 'High',
  'ktr.priority.medium': 'Medium',
  'ktr.priority.low': 'Low',
  'ktr.reason.approverIsPerformer': 'You cannot approve work you performed yourself. A review requires another person.',
  'ktr.reason.approverNotController': 'The firm has not declared you a reviewer.',
  'ktr.reason.approverUnknown': 'Could not find you as a member of the firm.',
  'ktr.reason.alreadyApproved': 'The review is already approved.',
  'ktr.reason.returnedToPerformer': 'The review has been returned to the performer.',
  'ktr.reason.noControlPoints': 'The review has no points.',
  'ktr.reason.pointMustBeFixed': 'At least one point is marked "Must be corrected".',
  'ktr.reason.pointNotAssessed': 'At least one point has not been assessed.',
  'ktr.reason.noteMissingText': 'A remark is missing text.',
  'ktr.reason.nothingToReturn': 'No points refer to anything. Mark what must be corrected first.',
  'ktr.reason.documentationRequestOpen': 'The document request you sent has not been answered yet.',
  'ktr.reason.conclusionRequired': 'The review has deviations or remarks. The conclusion must then be written.',
  'ktr.reason.basisChangedSinceSubmit': 'The figures have changed since the work was submitted. Ask for a new submission before you approve.',
  'ktr.reason.periodAreaBlocked': 'A subject area in the period has not been fully reviewed.',
  'ktr.reason.assigneeUnknown': 'Could not find the person as a member of the firm.',
  'ktr.reason.assigneeIsPerformer': 'The person who performed the work cannot be assigned to review it.',
  'ktr.reason.assigneeNotController': 'The firm has not declared this person a reviewer.',
  'ktr.diff.bookedBalance': 'Booked balance',
  'ktr.diff.unexplainedDifference': 'Unexplained difference',
  'ktr.diff.sameNumbers': 'The figures are the same as last time. The change is in the documentation or the explanations.',
  'ktr.diff.accountsChangedOne': '{count} account changed',
  'ktr.diff.accountsChangedMany': '{count} accounts changed',
  'ktr.diff.versionRange': 'version {from} → {to}',
  'ktr.diff.changed': 'Changed',
  'ktr.diff.added': 'Added',
  'ktr.diff.removed': 'Removed',
  'ktr.diff.performerReply': 'The performer\'s reply',
  'ktr.diff.changedAfterApproval': 'Changed after approval',
  'ktr.diff.resubmittedWhatChanged': 'Resubmitted — what changed',
  'ktr.diff.reopenAndRecheck': 'Reopen and review again',
  'ktr.col.priority': 'Priority',
  'ktr.col.client': 'Client',
  'ktr.col.period': 'Period',
  'ktr.col.scope': 'Scope',
  'ktr.col.performedBy': 'Performed by',
  'ktr.col.sentTitle': 'Sent for review',
  'ktr.col.sent': 'Sent',
  'ktr.col.deviationsTitle': 'Critical deviations',
  'ktr.col.deviations': 'Deviations',
  'ktr.col.progressTitle': 'Review progress',
  'ktr.col.progress': 'Progress',
  'ktr.col.assignedTitle': 'Assigned reviewer',
  'ktr.col.assigned': 'Assigned',
  'ktr.col.deadlineTitle': 'Review deadline',
  'ktr.col.deadline': 'Deadline',
  'ktr.col.status': 'Status',
  'ktr.col.periodApproval': 'Period approval',
  'ktr.notAssigned': 'Not assigned',
  'ktr.assignedControllerFor': 'Assigned reviewer for {name}',
  'ktr.overdueShort': 'overdue',
  'ktr.progressCount': '{done} of {total}',
  'ktr.noControlsMatch': 'No reviews match the filters.',
  'ktr.noClientsMatch': 'No clients match the filters.',
  'ktr.orgNumber': 'Org. {org}',
  'ktr.noOrgNumber': 'No org. no.',
  'ktr.open': 'Open',
  'ktr.openControl': 'Open review',
  'ktr.cell.notSent': 'Not sent for review',
  'ktr.cell.performedBy': 'Performed by {email}',
  'ktr.cell.assigned': 'Assigned to {name}',
  'ktr.cell.deadline': 'Deadline {deadline}',
  'ktr.cell.critical': '{count} critical deviations',
  'ktr.cell.version': 'Version {version}',
  'ktr.period.notSent': 'Not sent',
  'ktr.period.partlySent': 'Partly sent',
  'ktr.period.blocked': 'Blocked',
  'ktr.period.ready': 'Ready for period approval',
});
